export default [
  {
    path: '/active-gradereport-unite/index',
    name: 'index',
    component: () => import('@/views/active-gradereport-unite/index'),
    meta: {
      title: '分析报告'
    }
  },
  {
    path: '/active-gradereport-unite/my-list',
    name: 'my-list',
    component: () => import('@/views/active-gradereport-unite/my-list'),
    meta: {
      title: '分析报告'
    }
  },{
    path: '/active-gradereport-unite/buy-record',
    name: 'buy-record',
    component: () => import('@/views/active-gradereport-unite/buy-record'),
    meta: {
      title: '购买记录'
    }
  },{
    path: '/active-gradereport-unite/about-our',
    name: 'about-our',
    component: () => import('@/views/active-gradereport-unite/about-our'),
    meta: {
      title: '关于我们'
    }
  },{
    path: '/active-gradereport-unite/msg-input',
    name: 'msg-input',
    component: () => import('@/views/active-gradereport-unite/msg-input'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-unite/first-msg',
    name: 'first-msg',
    component: () => import('@/views/active-gradereport-unite/first-msg'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-unite/grade-report',
    name: 'grade-report',
    component: () => import('@/views/active-gradereport-unite/grade-report'),
    meta: {
      title: '高考录取预测报告'
    }
  },{
    path: '/active-gradereport-unite/pay',
    name: 'pay',
    component: () => import('@/views/active-gradereport-unite/pay'),
    meta: {
      title: '支付'
    }
  },{
    path: '/active-gradereport-unite/batch',
    name: 'batch',
    component: () => import('@/views/active-gradereport-unite/batch'),
    meta: {
      title: '查批次'
    }
  },{
    path: '/active-gradereport-unite/oneline',
    name: 'oneline',
    component: () => import('@/views/active-gradereport-unite/oneline'),
    meta: {
      title: '一分一段'
    }
  },{
    path: '/active-gradereport-unite/agreement',
    name: 'agreement',
    component: () => import('@/views/active-gradereport-unite/agreement'),
    meta: {
      title: '协议内容'
    }
  },{
    path: '/active-gradereport-unite/paySuccess',
    name: 'paySuccess',
    component: () => import('@/views/active-gradereport-unite/paySuccess'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/active-gradereport-unite/transit',
    name: 'transit',
    component: () => import('@/views/active-gradereport-unite/transit'),
    meta: {
      title: ''
    }
  },
  {
    path: '/active-gradereport-unite/home',
    name: 'home',
    component: () => import('@/views/active-gradereport-unite/home'),
    meta: {
      title: '高考录取预测报告'
    }
  },
]
